import { render, staticRenderFns } from "./importButton.vue?vue&type=template&id=453c622b"
import script from "./importButton.vue?vue&type=script&lang=js"
export * from "./importButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports